import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header-actions',
  standalone: false,
  templateUrl: './page-header-actions.component.html',
})
export class PageHeaderActionsComponent {}
